export default __webpack_public_path__ + "static/media/make-in-india.dbfede19.png";